export const CONSTANTS_DATA = {
  seeDetails: 'See Details',
  getInTouch: 'Get in touch',
  submit: 'Submit',
  footerShowAt: 'businessHeader',
  ackoLink: 'https://www.acko.com/',
  animationText: 'COMING\u00A0SOON',
}
